module.exports = __webpack_public_path__ + "static/img/b1-5-3.5e023d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-5-3.png
// module id = 5WoA
// module chunks = 1